import { render } from "./add-assets.vue?vue&type=template&id=4e584fc0"
import script from "./add-assets.vue?vue&type=script&lang=js"
export * from "./add-assets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__